import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo-win.svg";
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import {languages, raceEthnicities, countries} from "../../Common/MasterData";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import LanguageSelector from "../../Common/LanguageSelector";
import { useTranslation } from 'react-i18next';
import RegistrationDropdown from "../../CustomControls/RegistrationDropdown";
import { useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { useDispatch } from "react-redux";
import { setPartiallyVerified } from "../../Redux/verificationReducer";
import ErrorModal from "../../Components/Security/ErrorModal";
import { de } from "@faker-js/faker";


const RegistrationFormTwo = (isEditMode) => {
  const { t, i18n } = useTranslation();
    const dispatch= useDispatch();

  const isSSO = useSelector((state) => state.sso.isSSO); 
  const ssoDob = useSelector((state) => state.sso.ssoUserData);

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
const otherData = location.state?.otherData;
  const [formData, setFormData] = useState({
    dateOfBirth: isSSO? ssoDob.DOB.replace(/(\d{4})-(\d{2})-(\d{2})/,'$2/$3/$1'):"",
    phoneNumber: "",
    agreeToTexts: false,
    country: "",
    zipCode: "",
    language: "",
    raceEthnicity: "",
  });
  const [form3Data, setForm3Data]=useState();

  const { currentStep = 2, totalSteps = 2 } = location.state || {};


  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);

  // const formData1 = location.state;
  const formData1 = location.state?.formData || location.state?.formData1;

  useEffect(() => {
    if (location.state?.FormData1 ||location.state?.form2Data) {
      const incomingData = location.state.form2Data;
      setFormData(incomingData);
    }  
    if(location.state?.form3Data){
      setForm3Data(location.state.form3Data);
    }
    else {
      console.log("No combinedProviderData passed to form2.");
    }
  
  }, [location.state]);

  useEffect(() => {
  if (isHighmarkPortal) {
    setFormData((prev) => ({
      ...prev,
      country: "United States of America"
    }));
  }
}, [isHighmarkPortal]);
  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

     // If the field is phoneNumber, restrict input to numbers only
  if (id === "phoneNumber") {
    const numericValue = value.replace(/[^0-9]/g, ""); // Removes all non-numeric characters
    setFormData({
      ...formData,
      [id]: numericValue,
    });
  } else {
    const updatedFormData = {
      ...formData,
      [id]: type === "checkbox" ? checked : value,
    };

    // Clear ethnicity when Canada is selected
    if (id === "country" && value === "Canada") {
      updatedFormData.raceEthnicity = "";
    }

    setFormData(updatedFormData);
  }
  };

  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const navigate = useNavigate();

  const isValidForm = () => {
    let formErrors = {};
    const today = new Date();
    const sixteenYearsAgo = new Date(today.getFullYear() - 16, today.getMonth(), today.getDate());

    // Check if date of birth is selected and user is at least 16 years old
    // if (!formData.dateOfBirth || formData.dateOfBirth > sixteenYearsAgo) {
    //   formErrors.dateOfBirth = "You must be at least 16 years old.";
    // }

    // Validate date of birth format and value
    if (!formData.dateOfBirth) {
      formErrors.dateOfBirth = "Date of Birth is required.";
    }

    // Check for mandatory fields
    if (!formData.phoneNumber?.trim()) {
      formErrors.phoneNumber = "Phone Number is required.";
    }

    if (!formData.country?.trim()) {
      formErrors.country = "Country is required.";
    }

    if (!formData.zipCode?.trim()) {
      formErrors.zipCode = "Zip Code is required.";
    }    if (!formData.language?.trim()) {
      formErrors.language = "Language is required.";
    }

    // Only validate race/ethnicity if country is not Canada
    if (formData.country !== "Canada" && !formData.raceEthnicity?.trim()) {
      formErrors.raceEthnicity = "Race / Ethnicity is required.";
    }

    // if (!formData.agreeToTexts) {
    //   formErrors.agreeToTexts = "Please agree to the texts";
    // }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isValidForm()) {
      debugger
      const formattedDOB = new Date(formData.dateOfBirth).toLocaleDateString("en-US");
      // Combine formData (Form 2 data) with formData1 (Form 1 data)
      const combinedFormData = {
        // ...formData1,
        // ...formData,
        FirstName: formData1.firstName,
        LastName: formData1.lastName,
        PreferredName: formData1.preferredName,
        EmailID: formData1.email,
        PWD: formData1.password,
        ConfirmPassword: formData1.confirmPassword,
        AgreeTerms: formData1.agreeTerms,
        Country: formData.country,
        ZipCode: formData.zipCode,
        Language: formData.language,
        Ethnicity: formData.raceEthnicity,
        PhoneNo: formData.phoneNumber,
        DOB: formattedDOB,
        TextNotificationStatus: formData.agreeToTexts ? "Yes" : "No",
        // Add any other necessary values as required for _Params
        Version: "1.0",
        AppLanguage: "English",
        DeviceType: "PatientPortal", // Modify this if it's dynamic
        // Add default or dynamic values as necessary
        Company:  "",  // Ensure default if missing
        MemberID:  "",
        WhyHere:  "",
        WINBenefits: "Y",
        Promocode: ssoData.Promocode? ssoData.Promocode : "",
        Pronouns: "",
        UpdateFlag: "N",
        JourneyStatus: "",
        HealthPlanId: "",
        RelationshipStatus: "",
        IsHealthProfileCompleted: 0,
        BenefitProvider: ssoData.Promocode? "My employer": "",
        SubscriberID: "",
        Gender: "",
        Contract: "",
        SecureCode: "",
        Goal: "",
        CountryCode: "",
      };

       // Prepare the _Params object
      const paramsObject = { ...combinedFormData,
        EmployeeID: "",
        EmployeeFirstName: "",
        EmployeeLastName: "",
        RelationshiptoEmployee: "" };
// // Check if user is under 18
//     const dob = formData.dateOfBirth instanceof Date
//       ? formData.dateOfBirth
//       : new Date(formData.dateOfBirth);
//     const today = new Date();
//     const age = today.getFullYear() - dob.getFullYear() - (today < new Date(dob.setFullYear(today.getFullYear())) ? 1 : 0);
// debugger
//     if (!isSSO && age < 18) {
//       // Prepare minimal payload
//       const formattedDOB = dob.toLocaleDateString("en-US");
//       const minorPayload = {
//         Fname: formData1.firstName || "",
//         Lname: formData1.lastName || "",
//         DOB: formattedDOB,
//         GuardianFname: "",
//         GuardianLname: "",
//         GuardianDOB: "",
//         TelePhn: "",
//         Address: "",
//         Relation: "",
//         Emailid: "",
//         MinorValidation: "Y"
//       };
// debugger
// console.log("Minor access payload:", minorPayload);
//       try {
//         const response = await axios.post(
//           Endpoints.SaveMinorAccessConsent,
//           `_Params=${encodeURIComponent(JSON.stringify(minorPayload))}`,
//           {
//             headers: {
//               "Content-Type": "application/x-www-form-urlencoded"
//             }
//           }
//         );
//         console.log("API Response minor acess:", response.data);
//         debugger
//         if (response.data.result === 1) {
//           navigate("/minorscreen", { state:  combinedFormData} );
//           return;
//         } else if (response.data.result === 2) {
//       // Redirect to /winbenefitsoptions as per your flow
//       if (form3Data != null && form3Data != undefined) {
//         navigate("/winbenefitsoptions", { state: { combinedFormData, form3Data: form3Data } });
//       } else {
//         navigate("/winbenefitsoptions", { state: { combinedFormData, ssoDob } });
//       }
//       return;
//     } else if (response.data.result === 3) {
//       setModalMessage("Consent form has already been sent to your parent or guardian. We are still awaiting their response.");
//       setShowModal(true);
//       return;
//     } else if (response.data.result === 0) {
//       setModalMessage(response.data.resultText || "Unable to fetch minor access consent.");
//       setShowModal(true);
//       return;
//     }
//   } catch (error) {
//     setModalMessage("Unable to save minor access consent.");
//     setShowModal(true);
//     return;
//   }
//     }


if (isSSO && isHighmarkPortal) {
      // Hit the API endpoint using Axios
      setLoading(true);
      try {
        const response = await axios.post(Endpoints.CreateAccount,
                          null,
        {
          params: { _Params: JSON.stringify(paramsObject) },
        })
        console.log(response);
        if (response.data.Result === 2) {
          console.log(response.data.Message);
          console.log("Form submitted:", paramsObject);
           dispatch(setPartiallyVerified());
          navigate("/healthprofilesetup", {state:  
                  paramsObject
                   });
        } else {
         if(response.data.Result === 0){
            setShowModal(true);
            setModalMessage(response.data.Message);
          }
        }
      } catch (error) {
        console.error('API Error:', error);
        // Handle error, show message to the user
      } finally {
        setLoading(false);
      }
    } else {
      // Pass the combinedFormData to the next component (accesscode)
      if(form3Data!=null && form3Data!= undefined){
        navigate("/benefit-options", { state: {combinedFormData,form3Data:form3Data, otherData:{...otherData}} });
      }
      else{
        navigate("/benefit-options", { state: {combinedFormData,ssoDob} });
      }
    }
    } else {
      console.log('Form has errors:', errors);
    }
  };

  const handleBack = () => {
    navigate("/registration-form-one", { state: { formData1: formData1 , form2Data: formData, form3Data, otherData: {...otherData} } });
  };

  const handleDateChange = (date) => {
    if (!date) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        dateOfBirth: "",
      }));
      setFormData((prevData) => ({
        ...prevData,
        dateOfBirth: "",
      }));
      return;
    }
  
    if (typeof date === "string") {
      const cleanedDate = date.replace(/\s/g, ""); // Remove spaces
  
      // Validate MM/DD/YYYY format
      if (!validateDateFormat(cleanedDate) || cleanedDate.length !== 10) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          dateOfBirth: "Please enter the Date in MM/DD/YYYY format.",
        }));
        return;
      }
  
      // Ensure valid MM/DD/YYYY values
      const [month, day, year] = cleanedDate.split("/");
      const parsedDate = new Date(`${month}/${day}/${year}`);
  
      if (
        isNaN(parsedDate.getTime()) || // Invalid Date Object
        parseInt(month, 10) > 12 || // Month can't be > 12
        parseInt(day, 10) > 31 || // Day can't be > 31
        parsedDate > new Date() // Can't be in the future
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          dateOfBirth: "",
        }));
        return;
      }
    }
  
    // Clear errors if date is valid
    setErrors((prevErrors) => ({
      ...prevErrors,
      dateOfBirth: "",
    }));
  
    setFormData((prevData) => ({
      ...prevData,
      dateOfBirth: date,
    }));
  };
  
  // ✅ Validate date format MM/DD/YYYY
  const validateDateFormat = (value) => {
    const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    return regex.test(value);
  };
  
  // ✅ Prevent typing alphabets, spaces, and enforce a length of 10
  const handleKeyDown = (e) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
  
    // Allow only numbers (0-9) and slash (/), and necessary navigation keys
    if (!/[\d\/]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  
    // Enforce max length of 10
    const input = e.target.value;
    if (input.length >= 10 && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  
  // const handleDateChange = (date) => {
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     dateOfBirth: date,
  //   }));
  // };

const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  


  return (
    <div>
      {/* Header */}
      {/* <div> <LanguageSelector /></div> */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
          {isHighmarkPortal ? 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          : 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          }            
          </a>
        </nav>
      </header>

      {/* Body Section */}
      
      <div className="registration-block-main">
            {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}
          
          {/* registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form">
            <h3 className="page-heading-secondary-black">{t('nicetomeetyou')}</h3>
            <h3 className="page-heading-bold">{capitalizeFirstLetter(formData1.preferredName) || capitalizeFirstLetter(formData1.firstName)}</h3>
            <p>{t('setupyouraccout')}</p>
            <div className="registration-process-form-wrapper mt-5">
              <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label
                  htmlFor="dateOfBirth"
                  className="form-label win-form-label" // Add a class for better control
                  style={{ display: 'block' }} 
                >
                 {t('dateofbirth')}
                  <span className="form-label win-form-label-d mandatory"></span>
                </label>
                <DatePicker
                  selected={formData.dateOfBirth ? formData.dateOfBirth : null}
                  onChange={handleDateChange}
                  dateFormat="MM/dd/yyyy"
                  className="form-control win-form-control-d calendar-control mobile-view"
                  id="dateOfBirth"
                  placeholderText="MM/DD/YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={100}   // Display up to 100 years in the dropdown
                 // onKeyDown={(e) => e.preventDefault()} 
                  maxDate={new Date()} 
                  autoComplete="newpassword"
                  readOnly={isSSO}
                  onChangeRaw={(e) => {
                    handleDateChange(e.target.value); // Ensure real-time validation
                  }}
                  onKeyDown={handleKeyDown} // Restricts invalid characters dynamically
                />
                {errors.dateOfBirth && <div className="form-field-error-message">{errors.dateOfBirth}</div>}
              </div>
                <div className="mb-3">
                  <label
                    htmlFor="phoneNumber"
                    className="form-label win-form-label mandatory"
                  >
                    {t('phonenumber')}
                    <span className="form-label win-form-label-d mandatory"></span>
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control-d  mobile-view"
                    id="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    maxLength="50"
                    autoComplete="off"
                  />
                  {errors.phoneNumber && <div className="form-field-error-message">{errors.phoneNumber}</div>}
                </div>
                <div className="mb-3 form-check win-form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input"
                    id="agreeToTexts"
                    checked={formData.agreeToTexts}
                    onChange={handleInputChange}
                  />
                  <label
                    className="form-check-label checkbox-radio-text"
                    htmlFor="agreeToTexts"
                  >
                    {isHighmarkPortal ? t('form2msghighmark') : t('form2msg')}
                  </label>
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="country"
                    className="form-label win-form-label mandatory"
                  >
                    {t('selectcouontry')}
                  </label>
                  <RegistrationDropdown
                    id="country"
                    label={t("selectcouontry")}
                    options={countries.map((country) => ({
                      id: country.value,
                      name: country.label,
                    }))}
                    selectedOption={
                      countries
                        .map((country) => ({ id: country.value, name: country.label }))
                        .find((option) =>isHighmarkPortal
            ? option.name === "United States of America"
            : option.name === formData.country
        ) || null
                    }
                    onChange={handleInputChange}
                    searchable
                    disabled={isHighmarkPortal}
                  />
                  {errors.country && <div className="form-field-error-message">{errors.country}</div>}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="zipCode"
                    className="form-label win-form-label mandatory"
                  >
                    Zip/Postal Code
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control-d mobile-view"
                    id="zipCode"
                    value={formData.zipCode}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                  {errors.zipCode && <div className="form-field-error-message">{errors.zipCode}</div>}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="language"
                    className="form-label win-form-label mandatory"
                  >
                    {t('language')}
                  </label>
                  <RegistrationDropdown
                        id="language"
                        label={t("selectlanguage")}
                        options={languages.map((lang) => ({
                          id: lang.value,
                          name: lang.label,
                        }))}
                        selectedOption={
                          languages
                            .map((lang) => ({ id: lang.value, name: lang.label }))
                            .find((option) => option.name === formData.language) || null
                        }
                        onChange={handleInputChange}
                        searchable
                      />
                  {errors.language && <div className="form-field-error-message">{errors.language}</div>}
                </div>
                {formData.country !== "Canada" && (
                <div className="mb-3">
                  <label
                    htmlFor="raceEthnicity"
                    className="form-label win-form-label mandatory"
                  >
                    {t('ethncity')}
                  </label>
                  <RegistrationDropdown
                    id="raceEthnicity"
                    label={t("raceethncity")}
                    options={raceEthnicities.map((race) => ({
                      id: race.value,
                      name: race.label,
                    }))}
                    selectedOption={
                      raceEthnicities
                        .map((race) => ({ id: race.value, name: race.label }))
                        .find((option) => option.name === formData.raceEthnicity) || null
                    }
                    onChange={handleInputChange}
                    searchable
                  />
                  {errors.raceEthnicity && <div className="form-field-error-message">{errors.raceEthnicity}</div>}
                </div>
                )}
                <div className="mb-3 mt-4">
                {isHighmarkPortal ? (
                      <>
                      <div className="pagination-wrapper mt-5">
                        <button className="previous-btn" onClick={handleBack} type="button"></button>                        
                        <span className="me-3">{currentStep} of {totalSteps}</span>                        
                        <button className="next-btn" onClick={handleSubmit} type="button"></button>
                      </div>
                      </>
                    ) : (
                      <>
                  <button className="win-btn-secondary  mobile-view me-3 mb-2 mb-md-0" onClick={handleBack} type="button">{t('back')}</button>
                  <button className="win-btn-primary  mobile-view" onClick={handleSubmit} type="button">
                  {t('nextbutton')}
                  </button>
                  </>
                    )}
                </div>
              </form>
            </div>
          </div>
        </div>
        </div>

        <ErrorModal
          show={showModal}
          message={modalMessage}
          onClose={() => setShowModal(false)}
        />
        </div>
  );
};

export default RegistrationFormTwo;
